<template>
    <div>
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            key-property="cropId"
            search-url="/crop/search?sortField=createdAt&"
            create-url="/crop/save"
            delete-url="/crop/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            @onUpdateExportRequestTotal="onUpdateExportRequestTotal"
        >
        </c-search-form>
        <crop-create
            :propsItem="material"
            :cDialog="visibleCreateDialog"
            :ponds="ponds"
            :pondList0="pondList0"
            :pondAreas="pondAreas"
            :users="users"
            :staffs="staffs"
            :crops="crops"
            :seedNumber="seedNumber"
            :procedureWh="procedureWh"
            @closeCreateDialog="closeCreateDialog"
            @getPondList="getPondList"
            @getCropList="getCropList"
            @getProcedureWh="getProcedureWh"
            :formCreateName="formCreateName"
        />
    </div>
</template>

<script>

import CSearchForm from "../../../components/form/ManageForm";
import CropCreate from "./CropCreate.vue";
import axios from "axios";
import { areaContants } from "@/constants";
import moment from "moment";

export default {
    name: "material",
    components: { CropCreate, CSearchForm },
    data: () => {
        return {
            formName: "Vụ nuôi",
            formCreateName: "Thêm mới vụ nuôi",
            material: null,
            visibleCreateDialog: false,
            visibleUpdateExportRequestTotalDialog: false,
            ponds: [],
            pondList0: [],
            pondAreas: [],
            users: [],
            staffs: [],
            procedureWh: [],
            crops: [],
            cropId: '',
            seedNumber: [],
            timeReload: 0,
            fields: [
                {
                    value: "index",
                    text: "lang.common.index",
                    sortable: false,
                    headerStyle: "text-align:center;",
                },
                {
                    value: "code",
                    name: "code",
                    text: "Mã vụ",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center; width: 140px; margin: 0 -15px;",
                },
                {
                  value: "name",
                  name: "name",
                  text: "Tên vụ",
                  sortable: false,
                  search: true,
                  headerStyle: "text-align:center; width: 140px; margin: 0 -15px;",
                },
                {
                    value: "pondAreaId",
                    text: "Khu nuôi",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: 'pondAreaId',
                    items: [],
                    itemText: "categoryCode",
                    itemValue: "categoryId",
                    width: "120px",
                },
                {
                    value: "pondParent",
                    text: "Mã ao mẹ",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: 'pondParent',
                    items: [],
                    itemText: "code",
                    itemValue: "cropId",
                    width: "160px",
                },
                // {
                //     value: "seedNumber",
                //     width: "20%",
                //     text: "Số lượng giống (ngàn con)",
                //     sortable: false,
                //     search: true,
                //     headerStyle: "text-align:center",
                // },
                {
                    value: "seedNumber",
                    text: "Số lượng giống",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: 'seedNumber',
                    items: [],
                    itemText: "categoryName",
                    itemValue: "categoryId",
                    width: "120px",
                },
                {
                    value: "startDate",
                    text: "Ngày bắt đầu",
                    headerStyle: "text-align:center; width: 90px;",
                    dateFormat: 'dd/MM/yyyy',
                },
                {
                    value: "dropDate",
                    text: "Ngày thả giống/sang tôm",
                    headerStyle: "text-align:center; width: 110px;",
                    dateFormat: 'dd/MM/yyyy',
                },
                {
                    value: "endDate",
                    text: "Ngày kết thúc",
                    headerStyle: "text-align:center; width: 90px;",
                    dateFormat: 'dd/MM/yyyy',
                },
                {
                    value: "shrimpAgeView",
                    text: "Ngày tuổi tôm",
                    sortable: false,
                    search: true,
                    headerStyle: "text-align:center;",
                    width: "80px",
                    // renderItem: (item) => {
                    //     let shrimpAge = '';
                    //     let dropDate = '';
                    //     if (parseInt(item.pondParent) > 0 && item.dropDateParent != '' && item.dropDateParent != null) {
                    //         dropDate = moment(String(item.dropDateParent));
                    //     } else if (item.dropDate != '' && item.dropDate != null) {
                    //         dropDate = moment(String(item.dropDate));
                    //     }
                    //     if (dropDate != '') {
                    //         let endDate = moment();
                    //         if (item.endDate) {
                    //             endDate = moment(String(item.endDate));
                    //             if (endDate > moment()) endDate = moment();
                    //         }
                    //         if (endDate > dropDate) {
                    //             let dates = endDate.diff(dropDate, "days");
                    //             if (dates >= 0) {
                    //                 shrimpAge = dates;
                    //             }
                    //         }
                    //     }
                    //     return shrimpAge;
                    // },
                },
              {
                value: "cropNo",
                name: "cropNo",
                text: "Số thứ tự",
                width: "80px",
                sortable: false,
                search: true,
                headerStyle: "text-align:center;",
              },
                {
                    value: "status",
                    text: "lang.user.status",
                    search: true,
                    headerStyle: "text-align:center",
                    type: "select",
                    name: "status",
                    items: areaContants.areaStatus,
                    itemText: "text",
                    itemValue: "value",
                    width: "10%",
                },
                {
                  value: 'custom_action',
                  text: "Cập nhật số lượng xuất",
                  icon: "attach_money",
                  event: "onUpdateExportRequestTotal",
                  width: "100px",
                  color: "info"
                },
                {
                    value: "action",
                    text: "lang.common.actions",
                    sortable: false,
                    compound: true,
                    headerStyle: "text-align:center",
                    width: "100px",
                },
            ],
        };
    },

    created() {
        // ds ao
        this.getPondList();
        

        // danh sách vụ nuôi
        this.getCropList();
        this.getCropListAll();

        // khu nuôi
        axios.post( process.env.VUE_APP_API_URL + "/category/myArea")
            .then(
                (data) => {
                    if (data.length > 0) {
                        this.pondAreas = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "pondAreaId";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                }
            );

        // số lượng giống
        axios.post(
                process.env.VUE_APP_API_URL + "/category/listByTypeOrderByCodeAsc?type=SEEDNUMBER"
            )
            .then(
                (data) => {
                    if (data.length > 0) {
                        this.seedNumber = data;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "seedNumber";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data;
                        }
                    }
                }
            );

        // nhân viên
        axios
            .post(
                process.env.VUE_APP_API_URL + "/user/list", {}
            )
            .then((data) => {
                if (data.content.length > 0) {
                    this.users = data.content;
                }
            });
        
        // supply
            axios.post(
                process.env.VUE_APP_API_URL + "/user/search",
                {role: 11}
            )
            .then(
                (data) => {
                    if (data.items) {
                        this.staffs = data.items;
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "users";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data.content;
                        }
                    }
                }
            );

        // quy trình nuôi
        this.getProcedureWh();
    },

    methods: {
        openCreateDialog: function (item = null) {
            this.material = item;
            if (item == null) {
                this.formCreateName = 'Thêm mới vụ nuôi';
            } else {
                this.formCreateName = 'Cập nhật vụ nuôi';
            }
            this.visibleCreateDialog = true;
        },
        onUpdateExportRequestTotal : function (item) {
          this.$router.push({ path:  '/exportRequestTotalEdit/crop/' + item.cropId, query: {} });
        },
        closeCreateDialog: function () {
            this.material = null;
            this.visibleCreateDialog = false;
            this.timeReload = Math.floor(Math.random() * 100);
        },
        getPondList: function (areaId = 0) {
            const search = {};
            if (areaId > 0) search.areaId = areaId;
            axios.post(
                process.env.VUE_APP_API_URL + "/pond/search?pageSize=-1&page=-1&orderBy=asc",
                search
            )
            .then(
                (data) => {
                    if (data.items) {
                        this.ponds = data.items;
                        this.pondList0 = data.items.filter(function (e) {
                            return e.status == 0;
                        });
                    }
                }
            );
        },
        getCropList: function (areaId = 0) {
            const search = {status: 1};
            if (areaId > 0) search.pondAreaId = areaId;
            axios.post(
                process.env.VUE_APP_API_URL + "/crop/search?sortField=updatedAt&pageSize=-1&page=-1&orderBy=desc", search
            )
            .then(
                (data) => {
                    if (data.items) {
                        this.crops = data.items;
                    }
                }
            );
        },
        getCropListAll: function () {
            const search = {};
            let url =process.env.VUE_APP_API_URL + "/crop/search?sortField=updatedAt&pageSize=-1&page=-1&orderBy=desc";
            axios.post( url,search).then(
                (data) => {
                    if (data.items) {
                        let itemFields = this.fields.filter(function (e) {
                            return e.name == "pondParent";
                        });
                        if (itemFields != undefined && itemFields.length > 0) {
                            itemFields[0].items = data.items;
                        }
                    }
                }
            );
        },
        getProcedureWh: function (params = {}) {
            const search = {status: 1};
            if (params.seedNumber != undefined) search.seedNumber = params.seedNumber;
            if (params.areaId != undefined) search.areaId = params.areaId;
            axios.post(
                process.env.VUE_APP_API_URL + "/procedureWh/search?pageSize=-1&page=-1&orderBy=asc",
                search
            )
            .then(
                (data) => {
                    if (data.items) {
                        this.procedureWh = data.items;
                    }
                }
            );
        },
        formatShrimpAge(item) {
            let shrimpAge = '';
            let startDate = moment(String(item.startDate));
            let endDate = moment(String(item.endDate));
            let dates = endDate.diff(startDate, "days");
            if (dates > 0) {
                shrimpAge = dates;
            }

            return shrimpAge;
        },
    },

    destroyed() {},
};
</script>
